var styles = {"divider":"XLgPB38fKeE-"};

export { styles as default };
//# sourceMappingURL=Divider.module.css.js.map
